export default "__VITE_ASSET__CkYymiUb__"